import React, { Component } from 'react'
import hasHtmlClass from '../../hoc/hasHtmlClass';
import hasSlidebarRight from '../../hoc/hasSlidebarRight';
import MenuItemBuyTicket from './MenuItemBuyTicket'
import config from '../../config.json'
import getDayKey from '../../functions/getDayKey';
import getShowtimeKey from '../../functions/getShowtimeKey';
import hasPerformancePerCinemaFilter from '../../hoc/hasPerformancePerCinemaFilter';
import { MULTICINEMA } from '../../constants/multiCinemaModes';
const breakpoints = config.breakpoints

class MenuItemBuyTicketContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentCinema: '',
            currentMovieID: '',
            currentMovieDate: '',
            currentMovieShowtime: '',
            currentCinemaOption: '',
            currentMovieOption: '',
            currentMovieDateOption: '',
            currentMovieShowtimeOption: '',
            currentMovieDeeplink: '',
            iframeIsOpen: false,
            itemBuyTicketIsOpen: false,
        }

        this.changeCinema = this.changeCinema.bind(this) 
        this.changeMovieTitle = this.changeMovieTitle.bind(this) 
        this.changeMovieDate = this.changeMovieDate.bind(this) 
        this.changeMovieShowtime = this.changeMovieShowtime.bind(this)
        this.openIframe = this.openIframe.bind(this)
        this.onClickItemBuyTicket = this.onClickItemBuyTicket.bind(this)
    }

    onClickItemBuyTicket() {
        const { addHtmlClass, removeHtmlClass } = this.props
        const { itemBuyTicketIsOpen } = this.state

        if(itemBuyTicketIsOpen) {
            this.setState({
                itemBuyTicketIsOpen: false,
                iframeIsOpen: false,
                currentCinema: '',
                currentMovieID: '',
                currentMovieOption: '',
                currentMovieDate: '',
                currentCinemaOption: '',
                currentMovieDateOption: '',
                currentMovieShowtime: '',
                currentMovieShowtimeOption: ''
            })
            // removeHtmlClass('quick-tickets-is-active')
            removeHtmlClass('has-popup')
        } else {
            this.setState({
                itemBuyTicketIsOpen: true
            })
            // addHtmlClass('quick-tickets-is-active')
            addHtmlClass('has-popup')
        }
    }

    changeCinema(value, option) {
        if(value === '') {
            this.setState({
                currentCinema: '',
                currentCinemaOption: ''
            })
        } else {
            this.setState({
                currentCinema: value,
                currentCinemaOption: option
            })
        }
    }

    changeMovieTitle(value, option) {
       if(value === '') {
            this.setState({
                currentMovieID: '',
                currentMovieOption: ''
            })
        } else {
            this.setState({
                currentMovieID: value,
                currentMovieOption: option
            })
        }
    }

    changeMovieDate(value, option) {
        if(value === '') {
            this.setState({
                currentMovieDate: '',
                currentMovieDateOption: ''
            })
        } else {
            this.setState({
                currentMovieDate: value,
                currentMovieDateOption: option
            })
        }
    }

    changeMovieShowtime(value, option) {
        if(value === '') {
            this.setState({
                currentMovieShowtimeOption: '',
                currentMovieShowtime: ''
            })
        } else {
            this.setState({
                currentMovieShowtime: value,
                currentMovieShowtimeOption: option
            })
        }
    }

    openIframe(bool, url, showId, cinema) {
        if(bool) {
            this.setState({
                iframeIsOpen: {
                    deeplinkUrl: url,
                    showId: showId,
                    cinema: cinema
                }
            })
        } else {
            this.setState({
                iframeIsOpen: false
            })
        }
    }

    render() {
        const { movies, moviesOrder, translation, buyTicketAnimation, cinemas, clusterCinemas, currentCinemaPk, clusterCinemaOption, isMobile, filledWithColorClass} = this.props
        const {itemBuyTicketIsOpen} = this.state
        const currentCinema = currentCinemaPk ? cinemas[currentCinemaPk] : null
        const currentCinemaType = currentCinema ? currentCinema.scope.type : null
        const clusterCinemaActive = (clusterCinemaOption || currentCinemaType === MULTICINEMA) ? true : false
        const cinemaPkList = currentCinemaType === MULTICINEMA ? _.keys(cinemas) : clusterCinemas

        return (
            <>
                {itemBuyTicketIsOpen && <div className={"popup has-popup-close " + filledWithColorClass} onClick={this.onClickItemBuyTicket}></div>}
                <MenuItemBuyTicket
                    onClick={this.onClickItemBuyTicket}
                    changeMovieShowtime={this.changeMovieShowtime}
                    changeMovieDate={this.changeMovieDate}
                    changeCinema={this.changeCinema}
                    changeMovieTitle={this.changeMovieTitle}
                    state={this.state}
                    isMobile={isMobile}
                    itemBuyTicketIsOpen={itemBuyTicketIsOpen}
                    clusterCinemaActive={clusterCinemaActive}
                    cinemaPkList={cinemaPkList}
                    filledWithColorClass={filledWithColorClass}
                    cinemas={cinemas}
                    movies={movies}
                    moviesOrder={moviesOrder}
                    translation={translation}
                    buyTicketAnimation={buyTicketAnimation}
                    openIframe={this.openIframe}
                />
            </>
        )
    }
}

export default hasHtmlClass(hasSlidebarRight({breakpoint: breakpoints.slidebarNav})(hasPerformancePerCinemaFilter(MenuItemBuyTicketContainer)))